<template>
  <el-upload
    action="/action/upload?type=license"
    :on-preview="handleLicensePreview"
    :on-remove="handleLicenseRemove"
    :on-error="handleError"
    :on-success="handleLicenseSuccess"
    :before-upload="handleLicenseBeforeUpload"
    :file-list="fileList"
    :disabled="disabled"
    :accept="'.' + licenseFileType.join(',.')"
  >
    <el-button
      type="primary"
      :disabled="disabled"
    >
      {{ text }}
    </el-button>
    <div slot="tip" class="el-upload__tip">只能上传 {{ licenseFileType.join('/') }} 文件</div>
  </el-upload>
</template>

<script>
import { licenseFileType } from '../mixin.js'
import { validateFileExt } from '@/utils/validate.js'

export default {
  props: {
    text: {
      required: true,
      type: String
    },
    fileList: {
      required: true,
      type: Array
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      licenseFileType
    }
  },

  methods: {
    handleLicensePreview(file) {
      open(file.url, '_blank')
    },

    handleLicenseRemove(file, fileList) {
      this.$emit('update:fileList', fileList)
    },

    handleError(err, file, fileList) {
      const index = this.fileList.findIndex(item => item.id === file.id)
      this.fileList.splice(index, 1)
      this.$message.error('授权文件上传失败: ' + err.message)
    },

    handleLicenseSuccess(resp, file, fileList) {
      if (resp.code === 0) {
        const fileData = {
          url: resp.data.url,
          name: file.name,
          path: resp.data.file_id,
          md5: resp.data.md5,
          fileName: file.name,
        }
        this.fileList.push(fileData)
      } else {
        this.$message.error('上传授权文件异常: ' + resp.msg)
      }
    },

    handleLicenseBeforeUpload(file) {
      if (!validateFileExt(licenseFileType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return false
      }

      return true
    },
  }

}
</script>
